export function isHasPermission(modules: any[], permission: string, { isDisableCheck = false }: { isDisableCheck?: boolean } = {}): boolean {
  if (!modules && permission) return true;
  const allPermissions = modules.flatMap((m) => (Array.isArray(m.permissionIds) ? m.permissionIds : []));
  const isPermission = allPermissions.includes(permission);
  return isDisableCheck ? !isPermission : isPermission;
}
